import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import {
  setPropertiesPrestation,
  updateAdminPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { t } from "i18next"; // Assuming you are using i18next for translations

export const PrestationEditAdmin = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loadingEdit } = useSelector(state => state.prestation);
  const { user } = useContext(UserContext);

  const inputs = prestationCommentAdminInputs(prestation);

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const dispatch = useDispatch();
  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationEditAdmin);
  };
  const onSubmitForm = async data => {
    await dispatch(setPropertiesPrestation(data));
    await dispatch(updateAdminPrestation());

    close();
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationEditAdmin,
    containerStyle: { minWidth: "500px" },
    title: t("PrestationEditAdmin.title"),
    open: open,
    cancelText: t("PrestationEditAdmin.cancelText"),
    okText: t("PrestationEditAdmin.okText"),
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={close}>
        {t("PrestationEditAdmin.cancelText")}
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        loading={loadingEdit}
        disabled={loadingEdit}
        onClick={async () => {
          try {
            await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: t("PrestationEditAdmin.error", {
                count: e.errorFields.length,
              }),
            });
          }
        }}
      >
        {t("PrestationEditAdmin.okText")}
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const prestationCommentAdminInputs = prestation => {
  const { comment } = prestation;

  return [
    {
      hidden: !userHasLevel({
        only: {
          [roles.admin]: "crud", //
          [roles.permanance]: "crud", //
        },
      }),
      children: [
        {
          label: t("PrestationEditAdmin.commentLabel"),
          name: "comment.admin",
          hidden: !userHasLevel({
            only: {
              [roles.admin]: "crud", //
              [roles.permanance]: "crud", //
            },
          }),
          value: comment.admin,
          type: "textarea",
          row: 2,
          col: 24,
        },
      ],
    },
  ];
};
